import React from 'react';
import PropTypes from 'prop-types';
import styles from '../RewardScreen.module.scss';

import { StarRating } from 'constants/StarRating';
import SVGCharacters from 'icons/Components/SVGCharacters';
import SvgStar from 'icons/Components/Star';
import Lock from 'icons/Lock.svg';
import { getScreenReaderCardDetails } from 'utils/screen-reader-info';

const RewardCard = ({ card, handleClick, contentScaling }) => {
  const Char = SVGCharacters[card.character.character];
  let classes = [styles.RewardCard];
  card.status === 'unlocked' && classes.push(styles.unLocked);

  let onClick = null;
  if (card.levelsCompleted < 3 && card.status === 'unlocked') {
    onClick = () => handleClick(card);
  }

  return (
    <button
      id={`card-${card.character.character}`}
      className={`gss-button ${classes.join(' ')}`}
      onClick={onClick}
      data-status={card.status}
      aria-label={getScreenReaderCardDetails(card)}
    >
      <span className={[styles.Content, styles[`Content${contentScaling}`]].join(' ')}>
        {Char && <Char />}
      </span>
      {card.status === 'locked' && (
        <span className={styles.Lock}>
          <img src={Lock} alt="" />
        </span>
      )}
      <span className={styles.Stars}>
        {[...Array(StarRating)].map((val, idx) => {
          let ref = card.starRef && idx === card.levelsCompleted ? card.starRef : undefined;
          return (
            <div
              key={`star-${idx}`}
              className={idx + 1 <= card.levelsCompleted ? `${styles.StarOn}` : 'locked'}
              ref={ref}
            >
              <SvgStar />
            </div>
          );
        })}
      </span>
    </button>
  );
};

RewardCard.propTypes = {
  card: PropTypes.object,
  handleClick: PropTypes.func.isRequired,
  contentScaling: PropTypes.number
};

export default RewardCard;
